import { BackgroundProcessStatus } from './types';

/**
 * background_process timestamps are naive UTC and the list and detail endpoints serialise them
 * without an offset, which a browser reads as local time. Anything rendering one has to say so
 * explicitly, or the same run shows two times an hour apart depending on where it is displayed.
 */
export const asUtcDate = (value: string) =>
  new Date(/(Z|[+-]\d{2}:?\d{2})$/.test(value) ? value : `${value}Z`);

export function getStatusColor(status: BackgroundProcessStatus): string {
  switch (status) {
    case 'SUCCESS':
      return 'green';
    case 'FAILED':
      return 'red';
    case 'PROCESSING':
      return 'blue';
    case 'PENDING':
    default:
      return 'gray';
  }
}
